export var StatusLabel;
(function (StatusLabel) {
    StatusLabel["Active"] = "Active";
    StatusLabel["Inactive"] = "Inactive";
    StatusLabel["Pending"] = "Pending";
    StatusLabel["DataDeleted"] = "Data Deleted";
})(StatusLabel || (StatusLabel = {}));
export const STATUSES_OPTIONS = [
    {
        value: 'Active',
        label: StatusLabel.Active,
    },
    {
        value: 'Inactive',
        label: StatusLabel.Inactive,
    },
];
export const STATUSES_FILTER_OPTIONS = [
    {
        value: 'Active',
        label: StatusLabel.Active,
    },
    {
        value: 'Inactive',
        label: StatusLabel.Inactive,
    },
    {
        value: 'Pending',
        label: StatusLabel.Pending,
    },
];
export const SSO_EMAIL_CHANGE_BLOCKED_MESSAGE = 'Since you have SSO login enabled, please reach out to support to change your email.';
export const SSO_EMAIL_CHANGE_BY_ADMIN_BLOCKED_MESSAGE = 'User email cannot be changed, SSO is configured for this user.';
export const SSO_PASSWORD_CHANGE_BLOCKED_MESSAGE = 'Since you have SSO login enabled, your account has no password. Please sign in with SSO.';
//# sourceMappingURL=user.js.map